import styled from 'styled-components';
import { EventTypes } from 'modules/domains/segmentation';
import { AllowedActionMenuElements, ButtonOption } from 'ui/actionMenu/types';
import { colors } from 'ui/theme';
import { isTypeString } from 'utils/helpers';
import { getKeyByValue } from '@iterable/utils';
import { HUMAN_READABLE_ITERABLE_EVENTS } from 'constants/eventTypes';
import { Wrapper, Header, InsightHeaderProps } from './InsightHeader';
import { CustomInsightRemovalMenu } from './CustomInsightRemovalMenu';
import { useCustomBehavioralContext, useCustomDemographicContext } from './contexts';
import { InsightType } from '../domain';
import { useTranslation } from '../hooks';

const CustomWrapper = styled(Wrapper)`
  grid-template-columns: [title] 1fr [delete] min-content;
`;

const StyledSpan = styled.span`
  color: ${colors.red100};
`;

export const CUSTOM_INSIGHT_HEADER = 'custom-insight-header';

export const CustomInsightHeader = ({
  title,
  size,
  showDivider = false,
  type = null,
}: InsightHeaderProps) => {
  const { t } = useTranslation();
  const INSIGHT_REMOVAL_CONFIRM_TEXT = t('insights.customInsightRemoval');
  const insight = isTypeString(title) ? title : '';
  const { deleteDemographicContactProperty } = useCustomDemographicContext();
  const { deleteCustomBehavioralEvent } = useCustomBehavioralContext();
  const dataType = getKeyByValue(HUMAN_READABLE_ITERABLE_EVENTS, insight, EventTypes.CustomEvent);

  const deleteInsight =
    type === InsightType.demographics
      ? deleteDemographicContactProperty
      : deleteCustomBehavioralEvent;

  const options: ButtonOption[] = [
    {
      as: AllowedActionMenuElements.Button,
      content: <StyledSpan>{INSIGHT_REMOVAL_CONFIRM_TEXT}</StyledSpan>,
      id: 'remove-custom-insight-action',
      onClick: () => deleteInsight(insight, dataType),
    },
  ];

  if (!title) return null;

  return (
    <CustomWrapper data-test={title} $showDivider={showDivider} size={size}>
      <Header data-test={CUSTOM_INSIGHT_HEADER} $title={insight} $type={type}>
        {title}
      </Header>
      <CustomInsightRemovalMenu options={options} />
    </CustomWrapper>
  );
};
